import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Slider } from '@fragments';
import { IconLineDashed, IconReplace } from '@tabler/icons-react';
import ColorField from '../../ColorPicker';
import { PopoverAction } from '../controls';
import { isFilledIcon } from '../../../../model/icons';

export default function IconSection({ layer, update, colors, openElements }) {
  const { t } = useTranslation('artEditor');
  return <>
    <ColorField label={t('iconColor')} value={layer.color} brand={colors.brand} used={colors.used} onChange={color => update({ color }, { key: `${layer.id}:color` })} />
    {!isFilledIcon(layer.icon) && <PopoverAction icon={IconLineDashed} label={t('strokeWidth')}>
      <Slider label={t('strokeWidth')} min={0.5} max={4} step={0.1} value={layer.stroke_width} formatLabel={v => v.toFixed(1)}
        onChange={(_, value) => update({ stroke_width: value }, { key: `${layer.id}:stroke_width` })} />
    </PopoverAction>}
    <Button size="small" variant="text" color="overlay" preventLoading startIcon={<IconReplace />} onClick={openElements}>{t('replaceIcon')}</Button>
  </>;
}
